type RequestBody = Record<string, unknown> | unknown[] | string | number | boolean | null;

export default class FetchWrapper {
  baseURL: string;
  token: string;
  hasWarnedMissingToken: boolean;

  constructor(baseURL: string) {
    this.baseURL = baseURL;
    const envToken =
      import.meta.env.VITE_ARENA_TOKEN || import.meta.env.VITE_ArenaToken || import.meta.env.ArenaToken || "";
    this.token = typeof envToken === "string" ? envToken.trim() : "";
    this.hasWarnedMissingToken = false;
  }

  get(endpoint: string) {
    return this.#request(endpoint, { method: "GET" });
  }

  put(endpoint: string, body: RequestBody) {
    return this.#send("put", endpoint, body);
  }

  post(endpoint: string, body: RequestBody) {
    return this.#send("post", endpoint, body);
  }

  delete(endpoint: string, body: RequestBody) {
    return this.#send("delete", endpoint, body);
  }

  #send(method: string, endpoint: string, body: RequestBody) {
    return this.#request(endpoint, {
      method: method.toUpperCase(),
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  }

  async #request(endpoint: string, options: RequestInit = {}) {
    const headers: Record<string, string> = {
      ...((options.headers as Record<string, string>) || {}),
    };

    if (this.token) {
      headers.Authorization = `Bearer ${this.token}`;
    } else if (!this.hasWarnedMissingToken) {
      this.hasWarnedMissingToken = true;
      console.warn("Are.na token not found in runtime env. Set VITE_ARENA_TOKEN in .env and restart Vite.");
    }

    const response = await fetch(this.baseURL + endpoint, {
      ...options,
      headers,
    });

    const contentType = response.headers.get("content-type") || "";
    const payload = contentType.includes("application/json") ? await response.json() : await response.text();

    if (!response.ok) {
      const details =
        typeof payload === "string" ? payload : payload?.details?.message || payload?.error || "Unknown error";
      const authDebug = `auth_header=${Boolean(headers.Authorization)} token_length=${this.token.length}`;
      throw new Error(`${response.status} ${response.statusText}: ${details} (${authDebug})`);
    }

    return payload;
  }
}
